import module from 'nominas/finiquito/module.js'
import template from './template.html'

export class NominasFiniquitoEscenariosComponent {
  idProyecto
  idColaborador
  idFiniquito
  editable = false
  aplicado = null
  data = []
  desvinculando = false

  constructor (NominasFiniquitoEscenarios, $state) {
    this.NominasFiniquitoEscenarios = NominasFiniquitoEscenarios
    this.$state = $state
  }

  $onInit () {
    this.promise = this.NominasFiniquitoEscenarios.get(this.idProyecto, this.idColaborador, this.idFiniquito)
      .then((response) => (this.data = response.data))
      .finally(() => (this.validar()))
  }

  actualizar (item, data) {
    if (data.id_nomina) {
      this.$state.reload()

      return
    }

    this.data.splice(this.data.indexOf(item), 1, data)
    this.data = [...this.data]
    this.validar()
  }

  agregar (data) {
    this.agregando = false

    if (data) {
      this.$state.go('nominas.finiquito.escenario.calculo', {id_escenario: data.id_escenario})
    }
  }

  desvincular (data) {
    this.desvinculando = false

    if (data) {
      this.data.forEach((item) => item.id_nomina = null)
      this.validar()
    }
  }

  eliminar (item) {
    this.data.splice(this.data.indexOf(item), 1)
    this.data = [...this.data]
    this.validar()
  }

  validar () {
    this.aplicado = this.data.find((item) => item.id_nomina) || null
    this.editable = this.data.every((item) => !item.id_nomina)
  }
}

module.component('nominasFiniquitoEscenarios', {
  controller: NominasFiniquitoEscenariosComponent,
  template,
  bindings: {
    idProyecto: '<',
    idColaborador: '<',
    idFiniquito: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/finiquito/components/escenarios/component.js